import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-8",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertModal = _resolveComponent("AlertModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      role: "button",
      class: "default-btn outlined position-relative transition border-0 fw-medium text-white p-10 rounded-4 bg-success d-inline-block text-decoration-none",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.recoveryPassword()))
    }, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1))
        : _createCommentVNode("v-if", true),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.recovery_password')), 1 /* TEXT */)
    ]),
    _createVNode(_component_AlertModal, {
      id: "recovery_modal",
      title: _ctx.$t('feature.auth.$recovery_user_password.title'),
      message: _ctx.modal_message
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}